import { useMutation, useQueryClient } from '@tanstack/react-query';
import useApi from '../../../../../../../utils/AxiosWrapper';

interface GenerateReportPackInput {
  customerId: string;
  report_year: number;
}

export function useGenerateReportPack() {
  const { callProtectedApi } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      customerId,
      report_year,
    }: GenerateReportPackInput) => {
      const response = await callProtectedApi(
        `/accounting/${customerId}/report-packs/generate`,
        'post',
        { report_year }
      );
      return response?.data?.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['accounting-report-packs', variables.customerId],
      });
    },
  });
}
